<template>
    <v-select
          :items="langs"
          solo
          dense
          v-model="$i18n.locale"
          @change="changeLocale"
    >
    </v-select>
</template>

<script>

export default ({
  methods: {
      changeLocale(){
          localStorage.setItem("locale",this.$i18n.locale)
          this.$vuetify.lang.current = this.$i18n.locale
      },

      getLocale(){
          if(localStorage.getItem("locale") != null){
              this.$i18n.locale = localStorage.getItem("locale")
              this.$vuetify.lang.current = this.$i18n.locale
          }
      }
  },
    name: "SwitchLocale",
    data: () => ({
        langs: ['EN', 'FR', 'DE', 'HU','PL','SV','IT'] 
    }),
    mounted () {
        this.getLocale()
    },
})
</script>
